/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

export default {
  path: "/filevault",
  name: "filevault",
  children: [
    {
      path: "/",
      name: "filevault-index",
      load: () => import(/* webpackChunkName: 'filevault' */ "./default")
    },
    {
      path: "/tags",
      name: "filevault-tags",
      load: () => import(/* webpackChunkName: 'filevault' */ "./tags")
    },
    {
      path: "/collections",
      name: "filevault-collections",
      load: () => import(/* webpackChunkName: 'filevault' */ "./collections")
    },
    {
      path: "/collections/:collection",
      name: "filevault-collection",
      load: () => import(/* webpackChunkName: 'filevault' */ "./collection")
    },
    {
      path: "/lightbox/:lightbox",
      name: "filevault-lightbox",
      load: () => import(/* webpackChunkName: 'filevault' */ "./lightbox")
    },
    {
      path: "/asset/:id",
      name: "filevault-asset",
      load: () => import(/* webpackChunkName: 'filevault' */ "./asset")
    }
  ],
  action({ next, store, url }, { siteId }) {
    const state = store.getState();
    const modules =
      (((state.session || {}).USER_DATA || {}).group || {}).modules || [];
    if (!modules.includes("filevault")) {
      return {
        redirect: `/${siteId}/forbidden?redirect=${encodeURIComponent(
          url || ""
        )}`
      };
    }
    return next();
  }
};



// WEBPACK FOOTER //
// ./src/routes/client/site/filevault/index.js